import { render, staticRenderFns } from "./Board-views.vue?vue&type=template&id=c90e9ec6"
import script from "./Board-views.vue?vue&type=script&lang=js"
export * from "./Board-views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports